// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_33G9h_qbXRRjEvFFKP3vRh","spaceLeft":"_3hONUPfo5GVBvMb-bHh-39","spaceBoth":"_2mV_zgdObzmim5AuZg0jWT","spaceRight":"fjmfq1DTjJex82Qx8379O","available":"_1uQMj_PpgcmG9HhM1eGgf","available-amount":"EUfqNSKzoczY-rgYZiimh","available-currency":"_3vrfrhTcR_r2vJwPoWHjPI","loading":"_3ny5AEIaKD_uILK4Ix9Aax"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisEtherBalance.scss
// module id = 1312
// module chunks = 0